import { render } from "./Installation.vue?vue&type=template&id=b4aabe84&scoped=true"
import script from "./Installation.vue?vue&type=script&lang=js"
export * from "./Installation.vue?vue&type=script&lang=js"

import "./Installation.vue?vue&type=style&index=0&id=b4aabe84&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4aabe84"]])

export default __exports__